import { Component, inject } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { GridService, SearchGridComponent } from '../../../../tms-shared';
import { RoleService } from '../../services';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.scss',
  imports: [SearchGridComponent],
})
export class RolesComponent {
  protected readonly roleService = inject(RoleService);
  private readonly gridService = inject(GridService);

  protected columnDefs: ColDef[] = [
    this.gridService.text('name', $localize`Name`),
    this.gridService.text('description', $localize`Description`),
    this.gridService.checkbox('showSettings', $localize`Show Settings`),
  ];
}
